/**
 * Export filename convention (brief 01-export.md, "Notes for All Modes"):
 * `escherllate-<wpgId>-<date>.<ext>`, or the user's own sketch name if they've
 * named one.
 */
import { usePatternStore } from '@/stores/pattern';
import { useSketchbookStore } from '@/stores/sketchbook';

function todayStamp(): string {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD, matches the brief's example
}

function slugify(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'sketch';
}

/** Base filename (no extension) for the current sketch/pattern. */
export function exportBaseName(): string {
  const sketchbook = useSketchbookStore();
  const patternStore = usePatternStore();
  if (sketchbook.currentName && sketchbook.currentName !== 'Untitled') {
    return slugify(sketchbook.currentName);
  }
  return `escherllate-${patternStore.currentConfig.wpgId}-${todayStamp()}`;
}

/** Filename for an export. `baseOverride` (slugified) wins over the current
 *  sketch name — used by PSD render, which should name its output after the
 *  imported file rather than whatever document is currently open. */
export function exportFilename(ext: string, baseOverride?: string): string {
  const base = baseOverride ? slugify(baseOverride) : exportBaseName();
  return `${base}.${ext}`;
}
